import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ICourse } from '@/Module/Lesson/Model/DataModel';
import subscriptionService from '@/Module/Subscription/Service/SubscriptionService';

export const checkCourseHasSubscriptionV2Action = createAsyncThunk<
  boolean,
  { course_id: ICourse['id']; accessToken?: string }
>('subscription/checkCourseHasSubscriptionV2', ({ course_id, accessToken }, { signal }) => {
  return subscriptionService
    .courseCheckHasSubscriptionV2(course_id, signal, { disabledAutoError: true }, accessToken)
    .then(({ data: { data } }) => data);
});
